import { makeAutoObservable } from "mobx";

import { KnowledgeBaseQuota } from "../../@api";

import { UploadFile } from "../models/classes/upload-file.class";

export class ContentManagementStore {
  private _uploadFiles: UploadFile[] = [];
  private _quota: KnowledgeBaseQuota | undefined;

  private readonly _isIndexing: Map<string, boolean> = new Map<string, boolean>();

  constructor() {
    makeAutoObservable(this);
  }

  public get uploadFiles(): UploadFile[] {
    return this._uploadFiles;
  }

  public set uploadFiles(value: UploadFile[]) {
    this._uploadFiles = value;
  }

  public addFile(file: UploadFile) {
    this.uploadFiles.push(file);
  }

  public removeFile(file: UploadFile) {
    this.uploadFiles = this.uploadFiles.filter(f => f.id !== file.id);
  }

  public setKnowledgeBaseIsIndexing(knowledgeBaseId: string | undefined, isIndexing: boolean) {
    if (knowledgeBaseId?.length) {
      this._isIndexing.set(knowledgeBaseId, isIndexing);
    }
  }

  public isKnowledgeBaseIndexing(knowledgeBaseId: string | undefined): boolean {
    return (!!knowledgeBaseId?.length && this._isIndexing.get(knowledgeBaseId)) ?? false;
  }

  public isAnyKnowledgeBaseIndexing(): boolean {
    return Array.from(this._isIndexing.values()).some(isIndexing => isIndexing);
  }

  public get quota(): KnowledgeBaseQuota | undefined {
    return this._quota;
  }

  public set quota(value: KnowledgeBaseQuota | undefined) {
    this._quota = value;
  }
}
